/**
 * Active-nav highlight based on which section is currently in view.
 *
 * The viewport's "center" line is used as the trigger so the active link
 * updates the moment a section occupies the middle of the screen.
 */

export function setupActiveNav() {
  const sections = document.querySelectorAll('main section[id]');
  const links = document.querySelectorAll('.nav_links a[href^="#"]');
  if (!sections.length || !links.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const id = entry.target.id;
        links.forEach((link) => {
          const isMatch = link.getAttribute('href') === `#${id}`;
          link.classList.toggle('is-active', isMatch);
        });
      });
    },
    { threshold: 0, rootMargin: '-50% 0px -50% 0px' },
  );

  sections.forEach((s) => observer.observe(s));
}

/**
 * Updates the copyright year for any element carrying [data-current-year].
 */
export function setCurrentYear() {
  const year = new Date().getFullYear().toString();
  document.querySelectorAll('[data-current-year]').forEach((el) => {
    el.textContent = year;
  });
}
